module.exports = __webpack_public_path__ + "img/profile_noimg_circle.efc3eef.svg";